var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "el-form-item",
        { attrs: { prop: _vm.getPropName } },
        [
          _c("el-input", {
            attrs: { value: _vm.value },
            on: { input: _vm.onInput },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }